import styled, { keyframes } from 'styled-components'
import React from 'react'

// Define the shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`

interface SkeletonTextProps {
  width?: string
  height?: string
}

export const SkeletonText = styled.div<SkeletonTextProps>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '16px'};
  background: linear-gradient(90deg, #333333 25%, #444444 50%, #333333 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 3s infinite;
  border-radius: 4px;
`

// Usage example
const Skeleton = () => (
  <div>
    <SkeletonText width="100%" height="16px" />
    <SkeletonText width="80%" height="16px" style={{ marginTop: '8px' }} />
    <SkeletonText width="60%" height="16px" style={{ marginTop: '8px' }} />
  </div>
)

export default Skeleton
